import { SelectOption } from "../types/select";

export function getSelectOptionValue<TValue>(option?: SelectOption<TValue>): TValue | undefined {
  return option?.value;
}
